import React from 'react';
import { ButtonStyle } from "CommonControls/ButtonStyle";
import Button from "CommonControls/Button";
import PageNavigationController from "PageNavigation/PageNavigationController";
import { dicontainer } from "DIContainer";
import IEmptyState from "EmptyState";
import classNames from 'classnames';

interface IModalDialogProps {
    name?: string,
    title?: string,
    subtitle?: string
}

export default class ModalDialog extends React.Component<IModalDialogProps, IEmptyState> {
    private _pageNavigationController: PageNavigationController = dicontainer.get(PageNavigationController);
    private _htmlModalContainer?: HTMLDivElement;

    constructor(props: IModalDialogProps) {
        super(props);
        this.handleCloseButtonClick = this.handleCloseButtonClick.bind(this);
        this.handleModalContainerClick = this.handleModalContainerClick.bind(this);
    }

    public handleCloseButtonClick() {
        this._pageNavigationController.closeModal();
    }

    public handleModalContainerClick(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
        e.stopPropagation();
        if (e.target == e.currentTarget) {
            this._pageNavigationController.closeModal();
        }
    }

    public render() {
        return (
            <div className="modal-container" 
                onClick={this.handleModalContainerClick}
                ref={c => this._htmlModalContainer = c!}>
                <div className={classNames("modal", this.props.name)}>
                    <div className="header">
                        <div className="title">
                            <h2 className="main-title">{this.props.title}</h2>
                            {this.props.subtitle &&
                                <h4 className="subtitle">{this.props.subtitle}</h4>
                            }
                        </div>
                        <Button style={ButtonStyle.StandardTransparent} normalIconImage={"'./img/icons/cross-88919E.svg'"} onClick={this.handleCloseButtonClick} padded={false} />
                    </div>
                    <div className="content-container">
                        {this.props.children}
                        <div className="spacer"></div>
                    </div>
                </div>
            </div>
        );
    }
}